export const iso8601HourAndHalf = 'P5DT1H30M5S';
